/**
 * The engineer's own request history (`GET /api/entitlement/requests/mine/history`). It is the same shape as the
 * administrator's per-person history, so the two screens share one table. Gated on a signed-in person, not on a
 * permission, because every person may see their own requests.
 */
import { adminRequest, type AdminResult } from "./adminApi";
import type { PersonRequestHistoryItem } from "./requestsAdmin";

/** Calls `GET /api/entitlement/requests/mine/history`: every request the signed-in person has raised, newest first. */
export async function fetchMyRequestHistory(): Promise<AdminResult<PersonRequestHistoryItem[]>> {
  return adminRequest<PersonRequestHistoryItem[]>("/api/entitlement/requests/mine/history", { method: "GET" }, "my request history");
}
